import { render, staticRenderFns } from "./CitaPrevia.vue?vue&type=template&id=6c51f254&"
import script from "./CitaPrevia.vue?vue&type=script&lang=js&"
export * from "./CitaPrevia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports